'use strict';
import React from 'react';
import ReactDOM from 'react-dom';
import {stringAsCharPattern} from './helpers.js';
const TitleCard = require('./title-card.js');
const screen = require('./screen.js');

class MenuDefault extends React.Component {
  constructor() {
    super();
    this.pages = [
      {name: 'library', pathname: '/library', title: 'Library'},
      {name: 'news', pathname: '/news', title: 'News'},
      {name: 'about', pathname: '/about', title: 'About'},
      {name: 'contact', pathname: '/contact', title: 'Contact'}
    ];
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.routerLocation !== this.props.routerLocation) return true;
    return false;
  }

  createPageList() {
    return this.pages.map(function(page) {
      let current = this.props.routerLocation.pathname === page.pathname
        ? ' current'
        : '';
      return (
        <li>
          <h1 className="no-margin">
            <a className={"menu-link inner-page-link link" + current}
               href={page.pathname}
               onClick={this.props.toggleMobileMenu}>
              <span className="not-current">{page.title}</span>
              <span className="current">{stringAsCharPattern(page.title, '•')}</span>
            </a>
          </h1>
        </li>
      );
    }.bind(this));
  }

  brandClick(event) {
    if (document.body.classList.contains('home-menu')) {
      event.preventDefault();
      TitleCard.toggleMenu();
    }
    return;
  }

  render() {
    return (
      <div className="default" style={{display: (this.props.routerLocation.type === 'document' && (!screen.isMobile() && !screen.isTablet())) ? 'none': 'block'}}>
        <h1 className="desktop menu__default__brand" style={{marginBottom: '38px'}}><a className="inner-page-link" href="/" onClick={this.brandClick}>All Conference</a></h1>
        <ul className="no-bullet" style={{marginBottom: '84px', paddingLeft: 0}}>
          {this.createPageList()}
        </ul>
      </div>
    )
  }
}

module.exports = MenuDefault;



// WEBPACK FOOTER //
// ./src/js/menu-default.jsx